import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _PrintFontSizeModal;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, withStyleOverrides } from '@instructure/quiz-common';
import { Heading } from '@instructure/ui-heading';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
import { RadioInputGroup, RadioInput } from '@instructure/ui-radio-input';
import { Checkbox } from '@instructure/ui-checkbox';
export var PrintFontSizeModal = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_PrintFontSizeModal = /*#__PURE__*/function (_Component) {
  function PrintFontSizeModal() {
    var _this;
    _classCallCheck(this, PrintFontSizeModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PrintFontSizeModal, [].concat(args));
    _defineProperty(_this, "state", {
      selectedFontSize: null,
      rememberTextSizeSetting: false
    });
    // =============
    //   HELPERS
    // =============
    // =============
    //   HANDLERS
    // =============
    _defineProperty(_this, "handleSubmit", function () {
      _this.props.onSubmit(_this.state.selectedFontSize, _this.state.rememberTextSizeSetting);
    });
    _defineProperty(_this, "handleFontSizeChange", function (_, fontSize) {
      _this.setState({
        selectedFontSize: fontSize
      });
    });
    _defineProperty(_this, "handleRememberFontSize", function (e) {
      _this.setState({
        rememberTextSizeSetting: e.target.checked
      });
    });
    // =============
    //   RENDERING
    // =============
    _defineProperty(_this, "text", {
      printQuiz: t('Print Quiz'),
      close: t('Close'),
      cancel: t('Cancel'),
      printPreview: t('Print Preview'),
      rememberTextSizeSetting: t('Remember text size setting')
    });
    _defineProperty(_this, "sizes", [{
      label: t('Medium'),
      value: 'medium',
      size: '1'
    }, {
      label: t('Large'),
      value: 'large',
      size: '1.375'
    }, {
      label: t('X-Large'),
      value: 'xLarge',
      size: '1.75'
    }]);
    return _this;
  }
  _inherits(PrintFontSizeModal, _Component);
  return _createClass(PrintFontSizeModal, [{
    key: "componentDidMount",
    value:
    // =============
    //   LIFECYCLE
    // =============

    function componentDidMount() {
      this.setState({
        selectedFontSize: this.props.persistedPrintFontSize,
        rememberTextSizeSetting: !!this.props.persistedPrintFontSize
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        selectedFontSize: nextProps.persistedPrintFontSize || this.state.selectedFontSize,
        rememberTextSizeSetting: !!this.props.persistedPrintFontSize || this.state.rememberTextSizeSetting
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Modal, {
        open: this.props.isOpen,
        onDismiss: this.props.onCancel,
        onExited: this.props.onExited,
        size: "small",
        label: this.text.printQuiz
      }, jsx(ModalHeader, null, jsx(Heading, null, this.text.printQuiz), jsx(CloseButton, {
        onClick: this.props.onCancel,
        placement: "end",
        offset: "medium",
        screenReaderLabel: this.text.close
      })), jsx(ModalBody, null, jsx(RadioInputGroup, {
        onChange: this.handleFontSizeChange,
        name: "print-font-size",
        value: this.state.selectedFontSize,
        defaultValue: "medium",
        description: t('Text size'),
        "data-automation": "print-font-size-modal-radio-group"
      }, this.sizes.map(function (size) {
        var label = jsx("div", null, jsx("span", null, size.label), ' ', jsx("p", {
          "aria-hidden": "true",
          style: {
            fontSize: "".concat(size.size, "rem"),
            lineHeight: 1,
            margin: '1rem 0'
          }
        }, t('Printed quiz question')));
        var key = "print-font-size-modal-radio-button-key-".concat(size.value);
        var dataAutomation = "print-font-size-modal-radio-button-".concat(size.value);
        return jsx(RadioInput, {
          key: key,
          "data-automation": dataAutomation,
          inline: true,
          label: label,
          value: size.value
        });
      })), jsx("div", {
        css: this.props.styles.separator
      }), jsx(Checkbox, {
        label: this.text.rememberTextSizeSetting,
        checked: this.state.rememberTextSizeSetting,
        onChange: this.handleRememberFontSize
      })), jsx(ModalFooter, null, jsx(Button, {
        "data-automation": "sdk-print-font-size-cancel-button",
        color: "primary-inverse",
        onClick: this.props.onCancel,
        margin: "0 x-small 0 0"
      }, this.text.cancel), jsx(Button, {
        "data-automation": "sdk-print-font-size-print-preview-button",
        color: "primary",
        onClick: this.handleSubmit,
        margin: "0 x-small 0 0"
      }, this.text.printPreview)));
    }
  }]);
}(Component), _defineProperty(_PrintFontSizeModal, "displayName", 'PrintFontSizeModal'), _defineProperty(_PrintFontSizeModal, "componentId", "Quizzes".concat(_PrintFontSizeModal.displayName)), _defineProperty(_PrintFontSizeModal, "propTypes", {
  isOpen: PropTypes.bool,
  persistedPrintFontSize: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onExited: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_PrintFontSizeModal, "defaultProps", {
  isOpen: false,
  persistedPrintFontSize: 'medium'
}), _PrintFontSizeModal)) || _class);
export default PrintFontSizeModal;